<template>
	<div class="newForms" v-on:keyup.esc="ready = false">
		<div>
			<div class="activeSelection input-field" v-if="currentUser && currentUser.id">
				<input
				:disabled="dataDisabled"
				type="text" :name="dataOptions.name" @focus="ready = true" :id="dataOptions.name+ dataIndex" 
        :value="currentUser.id ? currentUser.acf.first_name+' '+currentUser.acf.last_name : 'select user'"
        />
        <label for="personCom">{{dataOptions.label}}</label>
				<button
				:disabled="dataDisabled"
					class="btn-floating btn-small btn-flat transparent right z-depth-0 waves-effect"
					@click="ready = true"
				>
					<i class="material-icons grey-text text-darken-3">edit</i>
				</button>
				&nbsp;
				<button
				:disabled="dataDisabled"
					class="btn-floating btn-small btn-flat transparent right z-depth-0 waves-effect"
					@click="currentUser = new Object"
				>
					<i class="material-icons grey-text text-darken-3">delete</i>
				</button>
          &nbsp;
				<div class="clear"></div>
			</div>
			<div v-else class="input-field">
				<input
				:disabled="dataDisabled"
					type="text" :name="dataOptions.name" @focus="ready = true" :id="dataOptions.name" 
         :value="currentUser.id ? currentUser.acf.first_name+' '+currentUser.acf.last_name : 'Select User'"
        />
				<label for="personCom">{{dataOptions.label}}</label>
			</div>
      <transition>
        <div class="custom-modal" v-if="ready" @blur="ready=false">
        <div class="col s12 tsc no-padding" 
				v-bind:class="[	componentState !== 'userLists' ? 'grey lighten-5' : '']"
				>
          <div class="buttons">
            <button class="btn-floating transparent z-depth-0 waves-effect">
            <i class="material-icons grey-text text-darken-3">search</i>
            </button>
            
          </div>
          <div class="searchbar">
            <input 
						:disabled="componentState !== 'userLists'"
						placeholder="Search User"
						type="search" name="userSearch" id="userSearch" v-model="userSearch" />
          </div>
          <div class="buttons right">
           <button @click="ready = false" class="btn-floating transparent z-depth-0 waves-effect right">
              <i class="material-icons grey-text text-darken-3">close</i>
           </button>
          </div>
          <div class="clear"></div>
        </div>
				<div class="otc" v-show="componentState === 'newUser'"
				:style="`--data-height:${dataHeight}px`"
				>
					<user-form
					:selected-company="activeCompany"
					:data-companies="companies.map(item => { return  {...item.acf, ...{id:item.id}}})"
					:data-users="allUsers.map(item => item.acf)"
					@update="$_setAddedUser($event)"
					>
					</user-form>
			
				</div>
				<div class="otc" v-if="componentState === 'newCompany'" :style="`--data-height:${dataHeight}px`">
					<company-form
						@update="$_setCompanyToUser($event)"
						:data-companies="companies.map(item => item.acf)">
					</company-form>
				</div>
        <div v-else-if="componentState === 'userLists'" class="collection" :style="`--data-height:${dataHeight}px`">
          <div
            @click="$_emitUser(user)"
            class="collection-item avatar waves-effect waves-block"
            v-for="user in allUsers"
            v-bind:key="user.id"
          >
            <img
              v-if="user.acf.avatar_url && user.avatar_url !== ''"
              :src="user.acf.avatar_url"
              class="circle"
              alt
            />
            <i v-else class="material-icons circle grey lighten-2" style="position:aboslute; z-index:-1">person</i>
            <span class="title" v-html="user.acf.first_name +' '+ user.acf.last_name"></span>
            <div>
							<span v-html="user.acf.position"></span>
							<span  v-if="user.acf.position"><br/></span>
              <span v-html="$_returnCompany(user.acf.company).title.rendered"></span>
            </div>
          </div>
        </div>
			
				<div class="cs-modal-footer">
			
					<button 
						v-tipped 
						data-tooltip="Select Users"
						@click="componentState = 'userLists'" class="btn-floating btn-small waves-effect z-depth-0 white">
						<i class="material-icons grey-text text-darken-3">list_alt</i>
					</button>
					<button 
						v-tipped  
						data-tooltip="Add User"
						@click="componentState = 'newUser'" class="btn-floating btn-small waves-effect z-depth-0 white">
						<i class="material-icons grey-text text-darken-3">person_add</i>
					</button>
					<button 
						v-tipped 
						data-tooltip="Add Company"
						@click="componentState = 'newCompany'" class="btn-floating btn-small waves-effect z-depth-0 white">
						<i class="material-icons grey-text text-darken-3">business</i>
					</button>
				</div>
      </div>
      </transition>
		</div>
		<div class="opened-overlay" v-if="ready" @click="ready = false"></div>
	</div>
</template>
<script>
import contentService from '@/services/contentService'
import userForm from '@/components/records/form/userForm.component'
import companyForm from '@/components/records/form/companyForm.component'
import core from "@/functions"
import {mapState} from 'vuex'
export default {
	name: "personCompany",
	props: {
		dataHeight: {
			type: Number,
			default: 400
		},
		dataIndex:{
			type:Number,
			default: Math.floor(Math.random() * 99),
		},
		dataDisabled:{
			type:Boolean,
			default:false,
		},
		dataOptions: {
			type: Object
		},
		dataType: {
			type: String,
			default: "clients"
		}
	},
	components:{
		companyForm,
		userForm,
	},
	data() {
		return {
			activeCompany:false,
			ready: false,
			userSearch: "",
			componentState:'userLists',
			currentUser: new Object(),
		};
	},
	mounted(){
		this.users.length < 1 
		? this.$_fetchUsers()
		: false
		this.companies.length < 1 
		? this.$_getCompanies()
		: false

		if(this.$route.name === 'new') {
			this.dataOptions.values && this.dataOptions.id
			? this.currentUser  = this.dataOptions.values
			: false
		}
		if(this.$route.name === 'view_record'){
		
			this.dataOptions.values
			? this.currentUser = this.users.find(user => user.id === this.dataOptions.values)
			: false

		}

		setTimeout(() => {
      core.updateFields()
    }, 600);
	},
	computed: {
		allUsers:{
			get() {
				const sortF = (arr) => {
					return arr.sort(function(a, b) {
						let textA = a.acf.first_name.toLowerCase();
						let textB = b.acf.first_name.toLowerCase();
						return textA < textB ? -1 : textA > textB ? 1 : 0;
					});
				}
				let userList = sortF(this.users)
				return userList.filter(person => {
					return core
						.fieldsToText(
							person.acf.first_name,
							person.acf.last_name,
							person.acf.email,
							this.$_returnCompany(person.acf.company).acf.name
						)
						.toLowerCase()
						.includes(this.userSearch.toLowerCase());
				});
			}
		},
		...mapState({
			users:state=> state.record.users,
			companies:state=> state.record.companies
		})
	},
	methods: {
		$_setAddedUser($event){
			let payload = {
				id:$event.data.id,
				acf:$event.data.acf
			}
			this.$_emitUser(payload)
		},
		$_setCompanyToUser(evt){
			const record = this.companies.findIndex(item => item.id === evt.id)
			record > -1 
			? this.activeCompany = this.companies[record]
			: this.activeCompany = false
			setTimeout(() => {
				record > -1 
				this.componentState = 'newUser'
			}, 300);
		},
		$_getCompanies(){
			contentService.getRecordsCompanies()
			.then(res=>{
				this.$store.commit('SAVE_COMPANIES', res.data)
			})
			.catch(err=>{
				window.console.warn(err)
			})

		},
		$_fetchUsers(){
			contentService.getRecordsUsers()
			.then(res=>{
				this.$store.commit('SAVE_USERS', res.data)
			})
			.catch(err=>{
				window.console.warn(err)
			})
		},
		$_returnCompany(id) {
			if(id){
			const record = this.companies.findIndex(item => item.id === parseInt(id));
			return record > -1 ? this.companies[record] : " ";
			}
			else {
				return {
					title:{
						rendered:"",
					},
					acf:{

					}
				}
			}

		},
		$_emitUser(user) {
			this.currentUser = user;
			this.ready = false;
			this.$emit("user", user);
		}
	}
};
</script>
<style scoped lang="scss">

.otc {
	height: var(--data-height);
	width: 100%;
	overflow: hidden;
	overflow-y: scroll;
	}	
	.collection, .otc {
		height: var(--data-height);
		overflow: hidden;
		overflow-y: scroll;
		margin: 0 !important;
		.collection-item {
			&.avatar {
				min-height: 70px;
				padding-left:56px;
				.title {
					font-size: 14px;
					font-weight: 500;
					letter-spacing: .36px;
					}
					.circle {
						width: 32px;
						height: 32px;
						left: 12px;
						line-height:32px;
						}
						p {
							margin: 0 !important;
						}
						span {
							font-size:13px; line-height:1.2;
						}
			}
		}
	}
.cs-modal-footer {
	padding:14px;
	button{
		margin:0 3px;
	}
}
.custom-modal {
	position: fixed;
	top: 50%;
	border-radius: 4px;
	left: 50%;
	width: 400px;
	margin: 0px;
	transform: translate(-50%, -50%);
	background: white;
	z-index: 999;
	box-shadow: 0px 2px 4px -1px rgba(0, 0, 0, 0.02),
		0px 4px 5px 0px rgba(0, 0, 0, 0.04), 0px 1px 10px 0px rgba(0, 0, 0, 0.02);

  .tsc {
    display: inline-flex;
    .searchbar {
      border-bottom: 1px solid rgba(0, 0, 0, 0.05);
      padding: 4px 0;
      height: 58px;
      width: calc(100% - 90px);
      border-top: 1px solid rgba(0, 0, 0, 0.06);
      input {
        border: none !important;
        box-shadow: none !important;
      }
    }
    .buttons {
      width: 48px;
      height: 40px;
      margin-top: 8px;
      text-align: center;
    }
  }
}
.opened-overlay {
	position: fixed;
	top: 0;
	left: 0;
	background: rgba(0, 0, 0, 0.22);
	width: 100%;
	height: 100%;
	z-index: 9;
}
</style>
<style lang="scss">
.newForms{
	.input-field.z >	label {
    left: 20px !important;
    width: auto;
	}
}
</style>